// Szrafury litologiczne wg legendy przekrojów hydrogeologicznych MhP 1:50 000 (zał. do objaśnień arkuszy,
// konwencja PIG jak na przekrojach SMGP) – port karty-cbdh/skrypty/szrafury.py (styl "mhp", stan z 13.10.2026):
// wzory bazowe, modyfikatory uziarnienia i domieszek (wzór pochodny „baza+mod+…”), pełna tabela barw wieku Q–Pr.
// W edytorze jako SVG <pattern> w układzie ekranu (stała gęstość znaków przy każdym powiększeniu).
// Barwa tła niesie wiek (z odcieniem litologii), szrafura – litologię.

type Znak =
  | ['dot', number, number, number]
  | ['seg', number, number, number, number]
  | ['ell', number, number, number, number]
  | ['bar', number, number, number, number]
  | ['wave', number, number, number];

export type Grupa = 'porowy' | 'szczelinowy' | 'ograniczony';

export interface Wzor { id: string; opis: string; grupa: Grupa; w: number; h: number; znaki: Znak[] }

const W = (id: string, opis: string, grupa: Grupa, w: number, h: number, znaki: Znak[]): Wzor => ({ id, opis, grupa, w, h, znaki });

/** Wzory bazowe (WZORY_MHP). */
export const WZORY: Wzor[] = [
  W('piasek', 'piaski', 'porowy', 7, 7, [['dot', 1.5, 1.5, 0.8], ['dot', 5, 5, 0.8]]),
  W('piasek_drobny', 'piaski drobnoziarniste', 'porowy', 5, 5, [['dot', 1.2, 1.2, 0.6], ['dot', 3.7, 3.7, 0.6]]),
  W('piasek_zwir', 'piaski, żwiry, otoczaki', 'porowy', 12, 10, [['dot', 2, 2, 0.8], ['dot', 6, 8, 0.8], ['dot', 11, 4, 0.8], ['ell', 8, 3, 1.4, 1.4]]),
  W('zwir', 'żwiry, otoczaki', 'porowy', 12, 10, [['ell', 3, 2.5, 1.6, 1.6], ['ell', 9, 7.5, 1.6, 1.6], ['dot', 9, 2.5, 0.7], ['dot', 3, 7.5, 0.7]]),
  W('piasek_pylasty', 'piaski pylaste, piaski z miką', 'porowy', 14, 10, [['dot', 2, 2, 0.8], ['dot', 11, 2, 0.8], ['dot', 6, 8.5, 0.8], ['wave', 4, 6, 6]]),
  W('piasek_gliniasty', 'piaski gliniaste', 'porowy', 12, 12, [['dot', 2, 2.5, 0.8], ['dot', 8, 9.5, 0.8], ['seg', 8, 1, 8, 6], ['ell', 8, 3.5, 1.1, 1.1], ['seg', 2, 7, 2, 12]]),
  W('piasek_wegiel', 'piaski z węglem brunatnym', 'porowy', 12, 10, [['dot', 2, 2, 0.8], ['dot', 10, 2, 0.8], ['dot', 6, 9, 0.8], ['bar', 5, 3, 2, 4]]),
  W('wapien', 'margle, wapienie, kreda', 'szczelinowy', 14, 10, [['seg', 0, 0.5, 14, 0.5], ['seg', 0, 5.5, 14, 5.5], ['seg', 7, 0.5, 7, 5.5], ['seg', 0, 5.5, 0, 10.5], ['seg', 14, 5.5, 14, 10.5], ['wave', 1.5, 3, 4], ['wave', 8.5, 8, 4]]),
  W('piaskowiec', 'piaskowce, zlepieńce', 'szczelinowy', 12, 8, [['dot', 2, 2, 0.8], ['dot', 8, 2, 0.8], ['seg', 0, 5.5, 12, 5.5], ['dot', 5, 7, 0.8]]),
  W('mulek', 'mułki, pyły', 'ograniczony', 14, 9, [['wave', 1, 2.5, 5], ['wave', 8, 7, 5]]),
  W('mulek_il', 'mułki ilaste, mułki z iłem', 'ograniczony', 14, 9, [['wave', 1, 2.5, 5], ['seg', 7.5, 7, 11.5, 7]]),
  W('mulek_wegiel', 'mułki i iły z węglem brunatnym', 'ograniczony', 16, 12, [['wave', 1, 3, 5], ['bar', 11, 1, 2, 5], ['wave', 8, 10, 5], ['bar', 3, 7.5, 2, 4]]),
  W('glina', 'gliny', 'ograniczony', 12, 14, [['seg', 3, 0, 3, 14], ['seg', 9, 0, 9, 14], ['ell', 3, 4, 1.1, 1.4], ['ell', 9, 11, 1.1, 1.4]]),
  W('glina_zwalowa', 'gliny zwałowe', 'ograniczony', 12, 14, [['seg', 3, 0, 3, 14], ['seg', 9, 0, 9, 14], ['ell', 3, 4, 1.1, 1.4], ['ell', 9, 11, 1.1, 1.4]]),
  W('il', 'iły', 'ograniczony', 12, 8, [['seg', 1, 2, 4.5, 2], ['seg', 7, 6, 10.5, 6]]),
  W('ilowiec', 'iłowce', 'ograniczony', 12, 6, [['seg', 0, 3, 12, 3]]),
  W('torf', 'torfy, namuły', 'ograniczony', 10, 12, [['bar', 1, 0, 1.6, 12], ['bar', 6, 0, 1.6, 12]]),
  W('wegiel', 'węgle brunatne', 'ograniczony', 10, 12, [['bar', 0.5, 0, 3, 12], ['bar', 6, 0, 3, 12]]),
  W('gleba', 'gleba, nasypy', 'ograniczony', 8, 8, [['seg', 2, 0, 2, 3], ['seg', 6, 4, 6, 7]]),
];

const BAZOWE = Object.fromEntries(WZORY.map((w) => [w.id, w])) as Record<string, Wzor>;

export const GRUPY: [Grupa, string][] = [
  ['porowy', 'Przepływ w ośrodku porowym'],
  ['szczelinowy', 'Przepływ w ośrodku szczelinowym'],
  ['ograniczony', 'Przepływ ograniczony, brak przepływu'],
];

// ---------------------------------------------------------------- modyfikatory uziarnienia i domieszek
export type Mod = 'grubo' | 'drobno' | 'rozno' | 'zwir' | 'piasek' | 'glina' | 'il' | 'pyl' | 'wegiel' | 'organ';
export const MOD_OPIS: Record<Mod, string> = {
  grubo: 'gruboziarniste', drobno: 'drobnoziarniste', rozno: 'różnoziarniste', zwir: 'ze żwirem / otoczakami',
  piasek: 'piaszczyste', glina: 'gliniaste', il: 'ilaste', pyl: 'pylaste / z miką', wegiel: 'z węglem brunatnym', organ: 'z częściami organicznymi',
};
export const MOD_KOLEJNOSC: Mod[] = ['grubo', 'drobno', 'rozno', 'zwir', 'piasek', 'glina', 'il', 'pyl', 'wegiel', 'organ'];
const SKALA_MOD: Partial<Record<Mod, number>> = { grubo: 1.3, drobno: 0.75 };
/** Cechy, które wzór bazowy już ma – modyfikator o tej cesze jest pomijany („piasek ze żwirem” to piasek_zwir). */
export const CECHY: Record<string, Mod[]> = {
  piasek: ['piasek'], piasek_drobny: ['piasek', 'drobno'], piasek_zwir: ['piasek', 'zwir'], zwir: ['zwir'], piasek_pylasty: ['piasek', 'pyl'],
  piasek_gliniasty: ['piasek', 'glina'], piasek_wegiel: ['piasek', 'wegiel'], wapien: [], piaskowiec: ['piasek'], mulek: ['pyl'],
  mulek_il: ['pyl', 'il'], mulek_wegiel: ['pyl', 'il', 'wegiel'], glina: ['glina'], glina_zwalowa: ['glina'], il: ['il'], ilowiec: ['il'],
  torf: ['organ'], wegiel: ['wegiel'], gleba: ['organ'],
};

const r2 = (v: number) => Math.round(v * 100) / 100;

/** Znaki domieszki w kafelku tw × th – położenia jako ułamki kafelka, więc pasują do każdej bazy (mod_znaki, styl mhp). */
function modZnaki(mod: Mod, tw: number, th: number): Znak[] {
  switch (mod) {
    case 'rozno': return [['dot', r2(tw * 0.75), r2(th * 0.3), 1.2]];
    case 'zwir': return [['ell', r2(tw * 0.3), r2(th * 0.7), 1.4, 1.4]];
    case 'piasek': return [['dot', r2(tw * 0.2), r2(th * 0.25), 0.8], ['dot', r2(tw * 0.7), r2(th * 0.8), 0.8]];
    case 'glina': return [['seg', r2(tw * 0.5), r2(th * 0.15), r2(tw * 0.5), r2(th * 0.85)], ['ell', r2(tw * 0.5), r2(th * 0.5), 1.1, 1.4]];
    case 'il': return [['seg', r2(tw * 0.3), r2(th * 0.5), r2(tw * 0.7), r2(th * 0.5)]];
    case 'pyl': return [['wave', r2(tw * 0.32), r2(th * 0.55), r2(tw * 0.36)]];     // między pionowymi liniami gliny, poniżej kółek
    case 'wegiel': return [['bar', r2(tw * 0.6), r2(th * 0.2), 2.0, r2(th * 0.5)]];
    case 'organ': return [['bar', r2(tw * 0.5), r2(th * 0.3), 1.2, r2(th * 0.4)]];
    default: return [];
  }
}

const skaluj = (z: Znak, k: number): Znak => (k === 1 ? z : [z[0], ...z.slice(1).map((v) => r2((v as number) * k))] as Znak);

export const bazaWzoru = (id: string | null | undefined) => (id ?? '').split('+')[0];
export const modyWzoru = (id: string | null | undefined) => (id ?? '').split('+').slice(1) as Mod[];

/** Id wzoru z bazy i modyfikatorów (kolejność kanoniczna, bez cech bazy; grubo wyklucza drobno). */
export function zlozWzor(baza: string, mody: Mod[]): string {
  const cechy = CECHY[baza] ?? [];
  let m = MOD_KOLEJNOSC.filter((x) => mody.includes(x) && !cechy.includes(x));
  if (m.includes('grubo')) m = m.filter((x) => x !== 'drobno');
  return m.length ? `${baza}+${m.join('+')}` : baza;
}

const pochodne: Record<string, Wzor> = {};
/** Definicja wzoru bazowego albo pochodnego „baza+mod…” (wzor_def). */
export function wzorDef(id: string | null | undefined): Wzor | null {
  if (!id) return null;
  if (BAZOWE[id]) return BAZOWE[id];
  if (pochodne[id]) return pochodne[id];
  const b = BAZOWE[bazaWzoru(id)];
  if (!b) return null;
  const mody = modyWzoru(id).filter((m) => m in MOD_OPIS);
  const k = mody.reduce((a, m) => a * (SKALA_MOD[m] ?? 1), 1);
  const tw = r2(b.w * k), th = r2(b.h * k);
  const znaki = [...b.znaki.map((z) => skaluj(z, k)), ...mody.flatMap((m) => modZnaki(m, tw, th))];
  pochodne[id] = { id, opis: [b.opis, ...mody.map((m) => MOD_OPIS[m])].join(', '), grupa: b.grupa, w: tw, h: th, znaki };
  return pochodne[id];
}

/** Zgodność wstecz: mapa wzorów bazowych. */
export const WZOR = BAZOWE;

// ---------------------------------------------------------------- barwy wieku
export type Wiek = 'Q' | 'Ng' | 'Pg' | 'Cr' | 'J' | 'T' | 'P' | 'C' | 'D' | 'S' | 'O' | 'Cm' | 'Pr';
/** Pełna tabela barw wieku (kolejność stratygraficzna) – konwencja map geologicznych (CGMW/ICS, jak SMGP i MhP). */
export const TLO_WIEK: Record<Wiek, [string, string]> = {
  Q: ['czwartorzęd', '#f7eaa8'], Ng: ['neogen', '#f0c86e'], Pg: ['paleogen', '#f4a460'], Cr: ['kreda', '#9fd38a'],
  J: ['jura', '#7fc8e0'], T: ['trias', '#b58cc8'], P: ['perm', '#e58a6a'], C: ['karbon', '#9fb7b0'], D: ['dewon', '#c9a46a'],
  S: ['sylur', '#b4dbc0'], O: ['ordowik', '#6fb8a0'], Cm: ['kambr', '#9fb58a'], Pr: ['prekambr', '#e8a0b8'],
};
export const WIEKI: [Wiek, string][] = (Object.keys(TLO_WIEK) as Wiek[]).map((k) => [k, TLO_WIEK[k][0]]);
const WIEK_ALIAS: Record<string, Wiek> = { Tr: 'Ng', M: 'Ng', Pl: 'Ng', Ol: 'Pg', E: 'Pg', Pc: 'Pg', K: 'Cr', Pt: 'Pr', 'Ng+Pg': 'Ng', 'Q/Ng': 'Q' };

const TLO_Q: Record<string, string> = {
  zwir: '#efe3a8', piasek_zwir: '#f3e6a6', piasek: '#f7eaa8', piasek_drobny: '#f7eaa8', piasek_pylasty: '#f2e4a9',
  piasek_gliniasty: '#e6d79a', piasek_wegiel: '#ead9a0', glina: '#c9a06a', glina_zwalowa: '#c2975f', mulek: '#d9d3b0',
  mulek_il: '#d2cba8', il: '#c9c2a0', ilowiec: '#bdb596', mulek_wegiel: '#c8bf98', wegiel: '#8f8468', torf: '#b9a98a',
  gleba: '#d8c9b0', wapien: '#dfe8ea', piaskowiec: '#e2d9c4',
};
const TLO_NG: Record<string, string> = {
  zwir: '#f0c86e', piasek_zwir: '#f0c86e', piasek: '#f0c86e', piasek_drobny: '#efc46a', piasek_pylasty: '#edc070',
  piasek_gliniasty: '#d9ab5e', piasek_wegiel: '#e3b866', glina: '#b08a4a', glina_zwalowa: '#b08a4a', mulek: '#a89f7a',
  mulek_il: '#a39a76', il: '#9c9270', ilowiec: '#8f8666', mulek_wegiel: '#9e9a7a', wegiel: '#6f6650', torf: '#8f8468',
  gleba: '#c0b494', wapien: '#c6d4d6', piaskowiec: '#cbbf9f',
};

/** Rozjaśnienie (czynnik > 0, ku bieli) albo przyciemnienie (czynnik < 0) barwy #rrggbb. */
function mix(hex: string, c: number): string {
  const v = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
  // zaokrąglenie połówek do parzystej – jak round() w Pythonie, żeby barwy były identyczne z szrafury.py
  const parz = (v: number) => { const r = Math.round(v); return Math.abs(v % 1) === 0.5 && r % 2 !== 0 ? r - 1 : r; };
  const f = (x: number) => parz(c >= 0 ? x + (255 - x) * c : x * (1 + c));
  return '#' + v.map((x) => f(x).toString(16).padStart(2, '0')).join('');
}

/** Barwa tła jednostki: wiek z odcieniem litologii (Q i Ng z tabel ręcznych, reszta liczona wg grupy przepływu). */
export function tloDla(wzor: string | null, wiek: Wiek | string): string {
  const b = bazaWzoru(wzor);
  const w = (WIEK_ALIAS[wiek] ?? wiek) as Wiek;
  if (w === 'Q') return TLO_Q[b] ?? '#dddddd';
  if (w === 'Ng') return TLO_NG[b] ?? '#dddddd';
  if (!TLO_WIEK[w]) return '#dddddd';
  const baz = TLO_WIEK[w][1], grupa = wzorDef(wzor)?.grupa ?? 'ograniczony';
  return mix(baz, grupa === 'porowy' ? 0.25 : grupa === 'szczelinowy' ? 0.1 : -0.12);
}

/** Wiek z symbolu stratygraficznego karty (Q, Ng, Pg, Tr, Cr, J…; najpierw aliasy, potem najdłuższy pasujący kod). */
export function wiekZeStratygrafii(st: string | null | undefined): Wiek {
  const t = (st ?? '').trim();
  if (!t) return 'Q';
  if (WIEK_ALIAS[t]) return WIEK_ALIAS[t];
  const kody = [...Object.keys(TLO_WIEK), ...Object.keys(WIEK_ALIAS)].sort((a, b) => b.length - a.length);
  const k = kody.find((c) => t.startsWith(c));
  if (!k) return 'Q';
  return (WIEK_ALIAS[k] ?? k) as Wiek;
}

// ---------------------------------------------------------------- SVG
const K = '#2b2b2b', KW = 0.8;

const fala = (x: number, y: number, w: number) => {
  const a = w / 5;
  return `M${x} ${y}c${w / 6} ${-a},${w / 3} ${-a},${w / 2} 0s${w / 3} ${a},${w / 2} 0`;
};

/** Id elementu <pattern> („+” nie jest dozwolony w id XML). */
export const idWzoru = (id: string, prefiks = 'mhp') => `${prefiks}-${id.replace(/\+/g, '--')}`;

/** Definicje <pattern> – wszystkie wzory bazowe i podane pochodne (raz w <defs>). */
export function WzoryDefs({ prefiks = 'mhp', dodatkowe = [] }: { prefiks?: string; dodatkowe?: (string | null | undefined)[] }) {
  const lista = [...WZORY, ...[...new Set(dodatkowe)].filter((id) => id && !BAZOWE[id]).map((id) => wzorDef(id)).filter((w): w is Wzor => !!w)];
  return (
    <>
      {lista.map((w) => (
        <pattern key={w.id} id={idWzoru(w.id, prefiks)} patternUnits="userSpaceOnUse" width={w.w} height={w.h}>
          {w.znaki.map((z, i) => {
            switch (z[0]) {
              case 'dot': return <circle key={i} cx={z[1]} cy={z[2]} r={z[3]} fill={K} />;
              case 'seg': return <line key={i} x1={z[1]} y1={z[2]} x2={z[3]} y2={z[4]} stroke={K} strokeWidth={KW} strokeLinecap="round" />;
              case 'ell': return <ellipse key={i} cx={z[1]} cy={z[2]} rx={z[3]} ry={z[4]} fill="none" stroke={K} strokeWidth={KW} />;
              case 'bar': return <rect key={i} x={z[1]} y={z[2]} width={z[3]} height={z[4]} fill={K} />;
              case 'wave': return <path key={i} d={fala(z[1], z[2], z[3])} fill="none" stroke={K} strokeWidth={KW} strokeLinecap="round" />;
            }
          })}
        </pattern>
      ))}
    </>
  );
}

/** Kafelek wzoru do palety i legendy. */
export function Kafelek({ wzor, tlo, w = 34, h = 20, prefiks = 'mhp' }: { wzor: string | null; tlo: string; w?: number; h?: number; prefiks?: string }) {
  return (
    <svg width={w} height={h} className="shrink-0">
      <rect x={0.5} y={0.5} width={w - 1} height={h - 1} fill={tlo} stroke="#555" />
      {wzor && <rect x={0.5} y={0.5} width={w - 1} height={h - 1} fill={`url(#${idWzoru(wzor, prefiks)})`} />}
    </svg>
  );
}
